<section
  class="section-fullscreen sec-getdemo sec-fullscreen-getdemo fp-section fp-table active"
  data-anchor="getdemo"
  id="id-getdemo"
>
  <div class="fp-tableCell">
    <div class="wrap">
      <div class="sec-form-block">
        <h3>Get Your FREE Behavioral Audit</h3>

        <form id="theForm" class="finalForm">
          <div style="display: none">
            <h4 for="comment">Are you a person?</h4>
            <textarea cols="1" rows="1" id="comment" name="comment"></textarea>
            <input
              type="hidden"
              value="tMtHjLjo5Hq9dYhcqH3UvT/+E2rNRdMVu4fDBOcr+ZE="
              name="idstamp"
              id="idstamp"
            />
          </div>

          <div class="finalForm-inner">
            <ol class="questions">
              <li class="current">
                <span><label class="infield" for="q1">What's your company website url?</label></span>
                <input class="input infield" id="q1" name="company" tabindex="1" type="text" />
              </li>
              <li>
                <span><label class="infield" for="q2">What's your full name?</label></span>
                <input class="input infield" id="q2" name="name" tabindex="2" type="text" />
              </li>
              <li>
                <span><label class="infield" for="q3">What's your work email?</label></span>
                <input class="input infield" id="q3" name="email" tabindex="3" type="email" />
              </li>
              <li>
                <span><label class="infield" for="q4">What's your estimated annual revenue?</label></span>
                <div class="select-arrow">
                  <select class="input infield dropdown" id="q4" name="annual_revenue" tabindex="4">
                    <option value="Under $2 million">Under $2 million</option>
                    <option value="$2 - $10 million">$2 - $10 million</option>
                    <option value="$10 - $100 million">$10 - $100 million</option>
                    <option selected value="More than $100 million">
                      More than $100 million
                    </option>
                  </select>
                </div>
              </li>
              <li>
                <span><label class="infield" for="q5">Last question, what's your work number?</label></span>
                <input class="input infield" id="q5" name="phone" type="tel" />
              </li>
            </ol>

            <button class="submit" type="submit">Send answers</button>
            <div class="controls">
              <button class="next show">Next</button>
              <div class="progress"></div>
              <span class="number">
                <span class="number-current">1</span>
                <span class="number-total">5</span>
              </span>
            </div>
          </div>

          <span class="error-message"></span>
          <h4 class="scheduler"></h4>
          <h4 class="final-message"></h4>
        </form>
      </div>
    </div>
  </div>
</section>
